// Helper to tag lab results for SubcategoryChart (Sistólica/Diastólica + Direita/Esquerda)

export interface TaggedResult {
  id: string;
  test_name: string;
  subcategory_id?: string | null;
  _isBloodPressure?: boolean;
  _bpSide?: 'sistolica' | 'diastolica';
  _isPair?: boolean;
  _side?: 'direita' | 'esquerda';
  [key: string]: any;
}

export function extractBloodPressureInfo(testName: string): {
  isBloodPressure: boolean;
  bpSide: 'sistolica' | 'diastolica' | null;
} {
  const lower = (testName || '').toLowerCase();
  if (lower.includes('sistólica') || lower.includes('sistolica')) {
    return { isBloodPressure: true, bpSide: 'sistolica' };
  }
  if (lower.includes('diastólica') || lower.includes('diastolica')) {
    return { isBloodPressure: true, bpSide: 'diastolica' };
  }
  return { isBloodPressure: false, bpSide: null };
}

export function extractPairSide(testName: string): 'direita' | 'esquerda' | null {
  const t = (testName || '').toLowerCase();
  if (/\bdireita\b|\(direita\)|\bdir\.?\b|\bd\b/.test(t)) return 'direita';
  if (/\besquerda\b|\(esquerda\)|\besq\.?\b|\be\b/.test(t)) return 'esquerda';
  return null;
}

/**
 * Tag a flat list of lab results with _isBloodPressure/_bpSide and _isPair/_side
 * flags so that SubcategoryChart renders sistólica/diastólica as a single combined chart.
 */
export function tagResultsForChart<T extends { test_name: string; id: string }>(
  results: T[]
): (T & { _isBloodPressure?: boolean; _bpSide?: 'sistolica' | 'diastolica'; _isPair?: boolean; _side?: 'direita' | 'esquerda' })[] {
  return results.map((r) => {
    const { isBloodPressure, bpSide } = extractBloodPressureInfo(r.test_name);
    if (isBloodPressure && bpSide) {
      return { ...r, _isBloodPressure: true, _bpSide: bpSide };
    }
    return r;
  });
}
